/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/transLists.config.json';
// import axios from "axios";

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { GET_TRANSACTION_LIST } from '../graphql';
import { VApplication } from '@/application';
import { StorageModule } from '@vlinder-web/storage-module-react';

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

import moment from 'moment';

export interface ITransactionsListMethods extends IPluginMethodMap {
  getTransactionsListProps(args: any): Promise<any>;
}

export interface IGetCredentialIssuedListProps {
  offset?: number;
  size?: number;
  where?: any;
}

export class TransactionsListService implements IAgentPlugin {
  readonly methods: ITransactionsListMethods;

  constructor() {
    this.methods = {
      getTransactionsListProps: this.getProps.bind(this),
    };
  }

  async getProps(args: IGetCredentialIssuedListProps) {
    const storageService = StorageModule?.getInstance();
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient('graphql-gateway');
    let _where1 = args?.where?.filter(
      (item: any) => item?.column === 'policyNumber'
    );
    let _where2 = args?.where?.filter(
      (item: any) => item?.column !== 'policyNumber'
    );
    const orgDetails = storageService?.get('myProfile', 'local')?.orgData;
    const orgId = orgDetails?.id;
    const orgType = orgDetails?.orgType;
    //try {
    // if (client) {
    //   const res = await client.query({
    //     query: GET_TRANSACTION_LIST,
    //     variables: {
    //       where: {
    //         namespace: {
    //           id: orgId,
    //         },
    //       },
    //       options: {
    //         limit: args?.size ?? 10,
    //         offset: args?.offset ?? 0,
    //         sort: [
    //           {
    //             createdAt: 'DESC',
    //           },
    //         ],
    //       },
    //     },
    //     fetchPolicy: 'network-only',
    //   });
    //   if (res?.data) {
    //     console.log(`table data`, res);
    //     let _rowData = this.formatTable(res?.data?.supplyChainStepTxns);
    //     const totalCount = '';
    //     return {
    //       ...config,
    //       ultUsers: _rowData,
    //       isEmpty: res?.data?.supplyChainStepTxns?.length <= 0,
    //       // studentGroup: holderGroups,
    //       activePage: res?.data?.supplyChainStepTxns?.currentPage,
    //       pageSize: res?.data?.supplyChainStepTxns?.pageSize,
    //       totalCount: res?.data?.supplyChainStepTxns?.totalCount,
    //       totalPages: res?.data?.supplyChainStepTxns?.totalPages,
    //     };
    //   }
    // }
    // } catch (err: any) {
    //   return {
    //     isEmpty: true,
    //   };
    // }
    return {
      ...config,
    };
    console.log(`orgType`, orgType);
    switch (orgType) {
      case 'farmer':
        return {
          ...config,
          ultUsers: config?.testUsers?.farmer,
          totalCount: config?.testUsers?.farmer?.length,
        };
      case 'ginningUnit':
        return {
          ...config,
          ultUsers: config?.testUsers?.ginningUnit,
          totalCount: config?.testUsers?.ginningUnit?.length,
        };
      case 'spinningUnit':
        return {
          ...config,
          ultUsers: config?.testUsers?.spinningUnit,
          totalCount: config?.testUsers?.spinningUnit?.length,
        };
      case 'weavingUnit':
        return {
          ...config,
          ultUsers: config?.testUsers?.weavingUnit,
          totalCount: config?.testUsers?.weavingUnit?.length,
        };
      case 'manufacturingUnit':
        return {
          ...config,
          ultUsers: config?.testUsers?.manufacturingUnit,
          totalCount: config?.testUsers?.manufacturingUnit?.length,
        };
      default:
        return {
          ...config,
          isEmpty: true,
        };
    }
  }

  private formatTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          rowData: item,
          id: item?.id,
          item: item?.item,
          batchNo: item?.batchNo,
          batchDate: item?.batchDate
            ? this.formatCreatedDate(item?.batchDate)
            : ' - ',
          batchExpiry: item?.batchExpiry
            ? this.formatCreatedDate(item?.batchExpiry)
            : ' - ',
        };
      });
    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    } else {
      return '';
    }
  }
}
